var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#F2F4F7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 22.75H16C15.4033 22.75 14.831 22.5129 14.409 22.091C13.9871 21.669 13.75 21.0967 13.75 20.5V16C13.75 15.4033 13.9871 14.831 14.409 14.409C14.831 13.9871 15.4033 13.75 16 13.75H20.5C21.0967 13.75 21.669 13.9871 22.091 14.409C22.5129 14.831 22.75 15.4033 22.75 16V20.5C22.75 21.0967 22.5129 21.669 22.091 22.091C21.669 22.5129 21.0967 22.75 20.5 22.75ZM16 15.25C15.8011 15.25 15.6103 15.329 15.4697 15.4697C15.329 15.6103 15.25 15.8011 15.25 16V20.5C15.25 20.6989 15.329 20.8897 15.4697 21.0303C15.6103 21.171 15.8011 21.25 16 21.25H20.5C20.6989 21.25 20.8897 21.171 21.0303 21.0303C21.171 20.8897 21.25 20.6989 21.25 20.5V16C21.25 15.8011 21.171 15.6103 21.0303 15.4697C20.8897 15.329 20.6989 15.25 20.5 15.25H16Z",
    fill: "#202A3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2975 18.25H11.2525C10.722 18.248 10.2138 18.0364 9.8387 17.6613C9.46359 17.2862 9.25198 16.778 9.25 16.2475V11.2525C9.25198 10.722 9.46359 10.2138 9.8387 9.8387C10.2138 9.46359 10.722 9.25198 11.2525 9.25H16.2475C16.778 9.25198 17.2862 9.46359 17.6613 9.8387C18.0364 10.2138 18.248 10.722 18.25 11.2525V14.05H16.75V11.2525C16.75 11.1192 16.6971 10.9914 16.6028 10.8972C16.5086 10.8029 16.3808 10.75 16.2475 10.75H11.2525C11.1192 10.75 10.9914 10.8029 10.8972 10.8972C10.8029 10.9914 10.75 11.1192 10.75 11.2525V16.2475C10.75 16.3808 10.8029 16.5086 10.8972 16.6028C10.9914 16.6971 11.1192 16.75 11.2525 16.75H14.2975V18.25Z",
    fill: "#202A3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateIcon);
export default __webpack_public_path__ + "static/media/duplicateIcon.c4442e6294bbf7b266f747433900bea0.svg";
export { ForwardRef as ReactComponent };